import { configureStore } from "@reduxjs/toolkit";
import { setupListeners } from "@reduxjs/toolkit/query";
import { authSlice } from "@unlikelyai-magic/shared/data-access/api";
import { policyqaApi } from "./policyqaApi";

export const store = configureStore({
  reducer: {
    auth: authSlice.reducer,
    [policyqaApi.reducerPath]: policyqaApi.reducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().concat(policyqaApi.middleware),
});

setupListeners(store.dispatch);

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
